<template>
  <div class="firebase-notification-list-container">
    <el-row>
      <el-table
        :data="firebaseMessageList"
        :show-header="false"
        :row-style="rowStyle"
        empty-text="無資料"
        v-loading="listLoading"
        style="width: 100%;">
        <el-table-column
          prop="created_at"
          label="發送時間"
          width="150">
          <template slot-scope="scope">
            <span>{{ scope.row | timeFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="platform"
          label="平台"
          min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.platform.join('、') }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="debug"
          label="測試OR正式"
          min-width="50">
          <template slot-scope="scope">
            <span>{{ scope.row.debug ? '測試' : '正式' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="發送結果"
          min-width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 'sending'" class="send-status sending">發送中 {{ scope.row.success_count + scope.row.failure_count }}/{{ scope.row.total_count }}</span>
            <span v-else-if="scope.row.status === 'failed'" class="send-status failed">發送中斷</span>
            <span v-else class="send-status">成功 {{ scope.row.success_count }}／失敗 {{ scope.row.failure_count }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="標題"
          width="250">
          <template slot-scope="scope">
            <span class="message-title">{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="message"
          label="內容"
          min-width="300">
          <template slot-scope="scope">
            <span>{{ scope.row.message }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <div class="create-new" @click="createNew()">
      <span class="tfam-new"></span>
    </div>
    <el-dialog
      title="新增推播"
      :visible.sync="firebaseDialogVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :center="true">
      <el-form v-if="firebaseMessageData" :rules="firebaseMessageRules" ref="firebaseForm" :model="firebaseMessageData" label-width="80px" label-position="left">
        <el-form-item label="標題">
          <el-input v-model="firebaseMessageData.title"></el-input>
        </el-form-item>
        <el-form-item label="內容" prop="message">
          <el-input
            type="textarea"
            :autosize="{ minRows: 5 }"
            v-model="firebaseMessageData.message"></el-input>
        </el-form-item>
        <el-form-item label="平台" prop="platform">
          <el-checkbox-group v-model="firebaseMessageData.platform">
            <el-checkbox label="iOS"></el-checkbox>
            <el-checkbox label="Android"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="測試" prop="debug">
          <el-checkbox v-model="firebaseMessageData.debug" label="是否為測試"></el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button
            class="tfam-button"
            v-loading.fullscreen.lock="fullLoading"
            plain
            @click="handleSubmitUpdate">儲存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { fetchFirebaseMessageList, createFirebaseMessage } from "../../api/firebaseMessage";
  import { parseTime } from '../../utils'

  export default {
    name: "FirebaseNotificationList",
    components: {
    },
    computed: {
      rowStyle: function () {
        return {
          height: '80px',
          cursor: 'default'
        }
      }
    },
    data() {
      return {
        firebaseMessageList: [],
        firebaseMessageData: undefined,
        firebaseDialogVisible: false,
        listLoading: false,
        fullLoading: false,
        // 背景發送中時定期更新列表
        refreshTimer: null,
        firebaseMessageRules: {
          message: [
            {required: true, message: '內容一定要填', trigger: 'blur'},
          ],
          platform: [
            { type: 'array', required: true, message: '請至少選擇一種平台', trigger: 'change' }
          ]
        }
      }
    },
    filters: {
      timeFilter: function (row) {
        return parseTime(row['created_at'], '{y}/{m}/{d} {h}:{i}')
      },
    },
    mounted() {
      this.getMessages()
    },
    beforeDestroy() {
      this.stopRefresh();
    },
    methods: {
      getMessages() {
        const filter = {
          order: 'created_at DESC',
          limit: 10
        };
        if (!this.refreshTimer) {
          this.listLoading = true;
        }
        fetchFirebaseMessageList(filter).then(response => {
          this.listLoading = false;
          this.firebaseMessageList = response.data;
          this.scheduleRefresh();
        }).catch(err => {
          this.listLoading = false;
          this.stopRefresh();
        })
      },
      scheduleRefresh() {
        this.stopRefresh();
        if (this.firebaseMessageList.some(item => item.status === 'sending')) {
          this.refreshTimer = setTimeout(() => {
            this.getMessages();
          }, 5000);
        }
      },
      stopRefresh() {
        if (this.refreshTimer) {
          clearTimeout(this.refreshTimer);
          this.refreshTimer = null;
        }
      },
      createNew() {
        this.firebaseDialogVisible = true;
        this.firebaseMessageData = {
          title: undefined,
          message: undefined,
          platform: ['iOS', 'Android'],
          debug: false
        }
      },
      handleSubmitUpdate() {
        this.$refs['firebaseForm'].validate((valid) => {
          if (valid) {
            this.submitUpdate();
          } else {
            return false;
          }
        });
      },
      submitUpdate() {
        this.fullLoading = true;
        this.asyncSubmitUpdate().then(res => {
          this.fullLoading = false;
          this.$refs['firebaseForm'].resetFields();
          this.firebaseDialogVisible = false;
          this.firebaseMessageData = undefined;
          this.$message({
            type: 'success',
            message: res.total_count > 0
              ? `已開始發送（共 ${res.total_count} 台裝置），結果會顯示在列表中`
              : '沒有符合條件的裝置'
          });
          this.getMessages();
        }).catch(err => {
          this.fullLoading = false;
          let message = err;
          if (err.response && err.response.data && err.response.data.error) {
            message = err.response.data.error.message + '!'
          }
          this.$alert(message, '發送失敗', {
            confirmButtonText: '確定'
          });
        })
      },
      asyncSubmitUpdate: async function() {
        try {
          const response = await createFirebaseMessage(this.firebaseMessageData);
          return Promise.resolve(response.data);
        } catch (e) {
          return Promise.reject(e);
        }
      }
    }
  }
</script>

<style lang="scss">
  .send-status {
    &.sending {
      color: #E6A23C;
    }
    &.failed {
      color: #F56C6C;
    }
  }
  .message-title {
    cursor: pointer;
  }
  .introduction-max-lines {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    -webkit-box-orient: vertical;
  }
</style>

